import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=031b77ac&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031b77ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('031b77ac')) {
      api.createRecord('031b77ac', component.options)
    } else {
      api.reload('031b77ac', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=031b77ac&scoped=true&", function () {
      api.rerender('031b77ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lw2XC6x8KdmS/JS/comp/SearchFilterTokens.vue"
export default component.exports